module.exports = __webpack_public_path__ + "../front/img/768_dobbelt_bøjlestang.ff9e0562.svg";